var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoPayslips(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 278,
    height: 158,
    viewBox: "0 0 278 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215.666 74.6279L3.52486 112.645",
    stroke: "#FB7C51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M276.105 125.22L225.136 83.5356L2.71637 112.358L276.105 125.22Z",
    stroke: "#FB7C51"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M212.681 84.7876L215.153 74.6589L186.308 48.3682L3.49619 112.171",
    stroke: "#FB7C51"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M207.172 121.234C207.45 125.836 208.379 130.794 207.511 135.337C206.793 139.089 207.957 143.374 206.669 146.924",
    stroke: "#FB7C51",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M206.583 145.504C198.198 146.012 189.921 144.663 181.634 143.951C176.194 143.484 171.058 142.069 165.634 141.566C158.291 140.886 151.014 140.279 143.656 139.543C136.18 138.795 129.145 137.029 121.725 135.933C118.047 135.39 114.654 134.733 110.931 134.606C107.458 134.488 104.457 133.15 100.942 133.362C90.336 134.004 80.3947 131.941 70.1666 129.944C63.4008 128.624 56.4425 126.228 49.7703 123.839C40.6523 120.574 31.0549 119.567 22.1034 115.613C18.459 114.003 5.57466 112.52 1.63981 111.564",
    stroke: "#FB7C51",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M166.768 90.8912L180.984 45.3638L71.2384 16.3638L45.7306 87.758L91.2234 100.212L166.768 90.8912Z",
    fill: "white",
    stroke: "#FB7C51"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9019 20.4458C51.4682 29.8085 60.1577 36.9667 70.39 36.3478C80.6223 35.7289 88.3856 27.5754 87.8193 18.2128C87.253 8.85015 78.5635 1.69191 68.3312 2.31084C58.0989 2.92977 50.3356 11.0832 50.9019 20.4458Z",
    fill: "white",
    stroke: "#FB7C51"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M177.289 60.7931C165.815 60.1176 156.808 68.8198 145.838 69.8232C144.199 69.9731 143.131 70.9372 141.597 71.0301C138.744 71.2026 136.084 72.3139 133.2 72.4883C126.721 72.8802 121.092 76.3394 114.614 76.9388C113.315 77.059 112.075 77.5675 110.686 77.6516C109.792 77.7057 106.702 76.4694 106.2 75.7582C105.12 74.2274 102.659 73.2791 100.971 72.4315C99.0823 71.4834 97.6697 69.7511 95.9924 68.5352C90.5607 64.598 86.7517 59.4762 82.1958 54.8768C80.3249 52.9881 78.5923 52.2574 77.0986 49.9581C75.4691 47.4499 72.3755 45.7953 70.5554 43.3318C69.7117 42.1898 67.408 41.0996 67.0054 39.9035C66.6104 38.7298 64.8866 37.2268 63.7307 36.7754",
    stroke: "#FB7C51",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M154.5 92.1076C150.022 83.6271 140.14 77.6636 132.688 71.5688",
    stroke: "#FB7C51",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0143 63.2214C84.768 62.8492 79.3778 64.0923 74.2386 65.0204C73.0291 65.2388 72.0594 65.1471 71.0286 65.7953C69.6082 66.6887 67.8036 66.282 66.2309 66.7719C64.7145 67.2443 63.5671 67.5958 62.0057 67.7667C58.9518 68.1009 55.9079 70.0362 52.8976 70.2183",
    stroke: "#FB7C51",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1588 23.9314L69.1675 23.8099L68.8179 18.0306C68.8044 17.8067 68.797 17.5709 68.7958 17.3233L67.442 18.6024C67.3856 18.6563 67.326 18.6943 67.2631 18.7164C67.2048 18.7383 67.1459 18.751 67.0865 18.7546C66.9951 18.7602 66.9094 18.747 66.8295 18.7151C66.7539 18.6784 66.6963 18.636 66.6567 18.588L66.0776 17.8868L68.9454 15.133L70.3371 15.0489L70.8608 23.7075L72.6433 23.5997L72.72 24.868L67.2355 25.1997L67.1588 23.9314Z",
    fill: "#FB7C51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPayslips);
export default __webpack_public_path__ + "static/media/noPayslips.913c41d78c4d70e61317564942826a5d.svg";
export { ForwardRef as ReactComponent };